/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldOption(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldOption',
      'aria-hidden': true,
      focusable: false,
      width:  57 * scale,
      height: 26 * scale,
      viewBox: '0 0 57 26',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M25 12H10v2h15zM54.1 1H2.9C1.9 1 1 1.9 1 2.9v20.2c0 1 .9 1.9 1.9 1.9h51.2c1.1 0 1.9-.9 1.9-1.9V2.9c0-1-.9-1.9-1.9-1.9m0 22.1H2.9V2.9h51.2zm-5.5-11.4-1.1-1.3-2.9 2.5-2.9-2.5-1.1 1.3 4.1 3.5z"}))
}
